
const Sleep = (duration) => {
	return new Promise((resolve) => {
		window.setTimeout(resolve, duration);
	});
};

function FormBlock() {
    window.grecaptcha.ready(() => {
        for (let formBlock of document.querySelectorAll('.form-block')) {
            const form = formBlock.querySelector('form');
            if (form === null) {
                continue;
            }
            form.addEventListener('submit', (event) => {
                const submitButton = form.querySelector('.submit');
                submitButton.setAttribute('disabled', 'disabled');
                submitButton.classList.add('wait');
                const recaptcha = form.querySelector('.recaptcha');
                if (recaptcha === null) {
                    return;
                }
                event.preventDefault();
                const badge = recaptcha.querySelector('.badge');
                const widgetId = window.grecaptcha.render(badge, {
                    sitekey: recaptcha.getAttribute('data-site-key'),
                    badge: 'invisible',
                    size: 'invisible',
                    callback: (event) => console.log("verify", event),
                });
                Promise.race([
                    window.grecaptcha.execute(),
                    /**
                     * In the event reCAPTCHA does not respond in a reasonable time,
                     * allow the form submission to ultimately continue
                     * and proceed to be saved as "likely spam".
                     **/
                    Sleep(2500),
                ]).then(() => {
                    form.submit();
                });
            });
            for (let field of formBlock.querySelectorAll('.field')) {
                if (!field.hasAttribute('data-conditional')) {
                    continue;
                }
                function updateVisibility() {
                    let conditional = JSON.parse(field.getAttribute('data-conditional'));
                    let conditionRule = ({
                        'all': Array.prototype.every,
                        'any': Array.prototype.some,
                    })[conditional.conditionRule];
                    let [showRule, inverseShowRule] = ({
                        'show': [Element.prototype.removeAttribute.bind(field, 'hidden'), Element.prototype.setAttribute.bind(field, 'hidden', 'hidden')],
                        'hide': [Element.prototype.setAttribute.bind(field, 'hidden', 'hidden'), Element.prototype.removeAttribute.bind(field, 'hidden')],
                    })[conditional.showRule];
                    if (conditionRule.call(conditional.conditions, function(condition) {
                        let operator = ({
                            '=': (fieldValue, conditionValue) => fieldValue === conditionValue,
                            '!=': (fieldValue, conditionValue) => fieldValue !== conditionValue,
                            '>': (fieldValue, conditionValue) => fieldValue > conditionValue,
                            '<': (fieldValue, conditionValue) => fieldValue < conditionValue,
                            'contains': (fieldValue, conditionValue) => fieldValue.includes(conditionValue),
                            'starts with': (fieldValue, conditionValue) => fieldValue.startsWith(conditionValue),
                            'ends with': (fieldValue, conditionValue) => fieldValue.endsWith(conditionValue),
                            'empty': (fieldValue) => fieldValue === "",
                        })[condition.operator];
                        let formData = new FormData(formBlock.querySelector('form'));
                        let fieldValue = formData.get(`fields[${condition.field}]`);
                        let conditionValue = condition.value;
                        return operator(fieldValue, conditionValue);
                    })) {
                        showRule.call();
                    }
                    else {
                        inverseShowRule.call();
                    }
                }
                formBlock.querySelector('form').addEventListener('change', function() {
                    updateVisibility();
                });
                updateVisibility();
            }
        }
        for (let dateFieldset of document.querySelectorAll('.date-fieldset')) {
            for (let label of dateFieldset.querySelectorAll('label')) {
                let input = label.querySelector('input');
                let button = label.querySelector('button');
                button.addEventListener('click', function() {
                    input.focus();
                    input.showPicker();
                });
            }
        }
    });
}

if ("grecaptcha" in window) {
    FormBlock();
}
else if ("onRecaptchaLoaded" in window) {
    const onRecaptchaLoaded = window.onRecaptchaLoaded;
    window.onRecaptchaLoaded = () => {
        onRecaptchaLoaded();
        FormBlock();
    }
}
else {
    window.onRecaptchaLoaded = FormBlock;
}
